import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "layer-account px-0"
  }, [_c('CloseButton', {
    staticClass: "sr-only",
    nativeOn: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.$emit('close');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "greeting-block"
  }, [_vm.user ? _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: {
        path: 'account-greeting',
        args: {
          name: _vm.user.firstName
        }
      },
      expression: "{ path: 'account-greeting', args: { name: user.firstName } }"
    }],
    staticClass: "greeting-text font-weight-bold pb-3 d-block"
  }) : _vm._e(), _vm._v(" "), _vm.renderLink ? _c('MdmLink', {
    staticClass: "btn d-block text-center",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": "",
      "url": _vm.accessUrl.dashboard
    },
    on: {
      "click": function click($event) {
        return _vm.navigate($event, _vm.accessUrl.dashboard);
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('account'))
    }
  })]) : _vm._e()], 1), _vm._v(" "), _vm._isMounted ? _c('ul', {
    staticClass: "list-unstyled quick-access"
  }, [_vm._l(_vm.quickAccessItems.length - 1, function (index) {
    return _c('li', {
      key: index,
      staticClass: "quick-access-item d-flex align-items-center mb-3",
      on: {
        "click": function click($event) {
          return _vm.tracking($event, _vm.quickAccessItems[index - 1].tracking);
        }
      }
    }, [_c('IconTextLink', {
      staticClass: "quick-link w-100",
      attrs: {
        "icon": _vm.quickAccessItems[index - 1].icon,
        "is-scramble-link": _vm.isScrambleLink,
        "label": _vm.$t(_vm.quickAccessItems[index - 1].name),
        "url": _vm.quickAccessItems[index - 1].link
      }
    }, [_c('mdm-icon', {
      staticClass: "p-0 m-0 mx-auto flex-shrink-0",
      attrs: {
        "size": "20",
        "name": "bx-chevron-right"
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('li', {
    staticClass: "quick-access-item d-flex align-items-center",
    on: {
      "click": function click($event) {
        return _vm.tracking($event, _vm.quickAccessItems[_vm.helpItemIndex].tracking);
      }
    }
  }, [_c('IconTextLink', {
    staticClass: "quick-link w-100",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink,
      "icon": _vm.quickAccessItems[_vm.helpItemIndex].icon,
      "label": _vm.$t(_vm.quickAccessItems[_vm.helpItemIndex].name),
      "url": _vm.quickAccessItems[_vm.helpItemIndex].link[_vm.locale.market][_vm.locale.language] || _vm.quickAccessItems[_vm.helpItemIndex].link[_vm.locale.market]
    }
  }, [_c('mdm-icon', {
    staticClass: "p-0 m-0 mx-auto flex-shrink-0",
    attrs: {
      "size": "20",
      "name": "bx-chevron-right"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('MdmLink', {
    staticClass: "btn logout-btn d-block text-center",
    attrs: {
      "url": _vm.logoutLink,
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": true
    },
    on: {
      "click": function click($event) {
        _vm.logout();
        _vm.tracking($event, {
          event_label: 'Se deconnecter'
        });
      }
    }
  }, [_c('mdm-icon', {
    staticClass: "fill-kraft",
    attrs: {
      "size": "14",
      "name": "logout"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logout-text pl-2",
    domProps: {
      "textContent": _vm._s(_vm.$t('logout'))
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };